export const getFileExtension = (filename = "") => {
  const parts = String(filename).split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};

// File signature for stable keys
export const getFileSignature = (file) => 
  `${file.name}|${file.size}|${file.lastModified}`;

// Format display title with extension
export const formatDisplayTitle = (metaTitle, originalName) => {
  const ext = getFileExtension(originalName);
  return metaTitle ? `${metaTitle}${ext ? `.${ext}` : ""}` : originalName;
};

// Get file type for display
export const getFileTypeDisplay = (fileType, filename) => {
  return fileType || getFileExtension(filename) || "unknown";
};

// Category lookup
export const getCategoryTitleById = (categoryId, categories) => {
  if (!categoryId || !categories || categories.length === 0) return "—";
  const category = categories.find((cat) => cat.id === categoryId);
  return category?.title || "—";
};

// Extract title without extension (used in FileUploadStepper)
export const getTitleWithoutExtension = (filename) => {
  return filename.split(".").slice(0, -1).join(".") || filename;
};

// Human readable file size (e.g. 1.2 MB)
export const formatFileSize = (bytes = 0) => {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1
  );
  const value = bytes / Math.pow(1024, exponent);
  return `${value.toFixed(exponent === 0 ? 0 : 1)} ${units[exponent]}`;
};
